import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin, Calendar } from "lucide-react";
import { PROJECTS } from "@/data/projects";

export default function FeaturedProject() {
  const project = PROJECTS[0];
  if (!project) return null;

  return (
    <section
      id="projects"
      data-testid="featured-project-section"
      className="relative bg-[#F9F8F6] py-24 sm:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-8 mb-14 sm:mb-16">
          <div className="reveal max-w-2xl">
            <p className="text-[11px] tracking-[0.4em] uppercase text-[#5C6658] mb-6">
              03 / Recent work
            </p>
            <h2 className="font-[Outfit] font-extralight text-[#2D332B] text-[36px] sm:text-[52px] leading-[1.05] tracking-[-0.015em]">
              A closer look at
              <br />
              <span className="italic text-[#8A9A86]">
                what we&rsquo;ve been building.
              </span>
            </h2>
          </div>
        </div>

        <Link
          to={`/projects/${project.slug}`}
          data-testid={`featured-project-${project.slug}`}
          className="reveal group grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-14 items-center border border-[#E5E1DB] rounded-sm overflow-hidden bg-[#F9F8F6] hover:border-[#8A9A86] transition-colors duration-500"
        >
          <div className="lg:col-span-7 relative aspect-square lg:aspect-[4/5] overflow-hidden">
            <img
              src={project.cover}
              alt={project.title}
              className="w-full h-full object-cover object-top transition-transform duration-[1600ms] group-hover:scale-[1.04]"
            />
          </div>
          <div className="lg:col-span-5 p-8 sm:p-12">
            <p className="text-[10px] tracking-[0.3em] uppercase text-[#5C6658]">
              Event · {project.year}
            </p>
            <h3 className="mt-5 font-[Outfit] font-light text-[32px] sm:text-[42px] text-[#2D332B] leading-[1.05] tracking-[-0.01em]">
              {project.title}
            </h3>
            <p className="mt-3 italic font-[Outfit] font-light text-[18px] sm:text-[20px] text-[#8A9A86]">
              {project.role}
            </p>

            <div className="mt-8 space-y-3 text-[13px] tracking-[0.15em] uppercase text-[#5C6658]">
              <p className="flex items-center gap-3">
                <MapPin className="w-3.5 h-3.5 text-[#8A9A86]" />
                {project.venue}
              </p>
              <p className="flex items-center gap-3">
                <Calendar className="w-3.5 h-3.5 text-[#8A9A86]" />
                {project.date_label}
              </p>
            </div>

            <p className="mt-8 text-[15px] leading-relaxed text-[#5C6658] line-clamp-4">
              {project.summary}
            </p>

            <span className="mt-10 inline-flex items-center gap-2 text-[11px] tracking-[0.3em] uppercase text-[#2D332B] group-hover:text-[#8A9A86] transition-colors">
              View event <ArrowUpRight className="w-3.5 h-3.5" />
            </span>
          </div>
        </Link>
      </div>
    </section>
  );
}
